module.exports = __webpack_public_path__ + "img/our-products-3.269d4f7.svg";